export default __webpack_public_path__ + "static/streaming-ece63ab9ebf35e26f654a031ee99b5c2.png";